module.exports = __webpack_public_path__ + "img/image-icon.5f33acc3.svg";